import { type ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  description?: ReactNode;
}

export function PageHeader({ title, description }: PageHeaderProps) {
  return (
    <div>
      <h2 className="text-2xl font-bold tracking-tight text-slate-900">{title}</h2>
      {description != null && (
        <p className="mt-1 text-slate-500">{description}</p>
      )}
    </div>
  );
}
